<div class="login-container">
  <div class="header"><img src="assets/images/common/logo.png" [alt]="'LogChain' | translate"></div>
  <div class="main-container">
    <div class="login-card align-center-item">
      <div class="header-cart mb-5">
        <div class="top">
          <div class="left">
            {{'Welcome to' | translate}} <b>Log</b>Chain!
          </div>
          <div class="right">{{ getToday() }}</div>
        </div>
        <div class="title text-center mt-3">{{'Reset Password' | translate}}</div>
        <div *ngIf="isForgotPassword" class="sub-title text-center">{{"Enter your email address & we'll send you a code to reset your password." | translate}}</div>
        <ngb-alert class="mt-3" *ngIf="errorMsg != ''" [type]="'danger'" [dismissible]="false" >{{ errorMsg }}</ngb-alert>
        <ngb-alert class="mt-3" *ngIf="successMsg != ''" [type]="'success'" [dismissible]="false" >{{ successMsg }}</ngb-alert>
      </div>
      <form *ngIf="isForgotPassword" [formGroup]="forgotPassForm">
          <div class="form-group">
            <input type="text" class="form-control" formControlName="email" required [placeholder]="'Enter your email' | translate ">
            <small *ngIf="forgotPassControl.email.touched && forgotPassControl.email.invalid" class="form-text text-danger">{{getEmailErrorMessage()}}</small>
          </div>

          <div class="btn-group">
            <button type="button" class="btn btn-secondary mr-3" (click)="backToLogin()">{{'Back to Login' | translate}}</button>
            <button type="submit" class="btn btn-primary" [disabled]="forgotPassForm.invalid" (click)="sendRequest()">
              <span *ngIf="!isLoading">{{ 'Send' | translate }}</span>
              <div *ngIf="isLoading" class="spinner-border"></div>
            </button>
          </div>
      </form>

      <form *ngIf="!isForgotPassword" [formGroup]="newPasswordForm">
        <div class="form-group">
          <label>{{ 'Verification code' | translate }}</label>
          <input type="text" class="form-control" formControlName="code" required autocomplete="new-password" maxlength="6">
          <small *ngIf="newPasswordControl.code.touched && newPasswordControl.code.invalid" class="form-text text-danger">{{getCodeErrorMessage()}}</small>
        </div>
        <div class="form-group mb-2">
          <label>{{ 'New password' | translate }}</label>
          <div class="input-group">
            <input [type]="hide ? 'password' : 'text'" class="form-control" formControlName="password" required autocomplete="new-password">
            <div class="input-group-append eye-icon">
              <span (click)="hide = !hide" class="input-group-text" style="border:none;" ><mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon></span>
            </div>
          </div>
          <small *ngIf="newPasswordControl.password.touched && newPasswordControl.password.invalid" class="form-text text-danger">{{getPasswordErrorMessage()}}</small>
        </div>
        <div class="text-right mb-4">{{ 'Lost your code?' | translate }} <span class="resend-code" (click)="resendCode()">{{ 'Resend code' | translate }}</span></div>

        <div class="btn-group">
          <button type="button" class="btn btn-secondary mr-3" (click)="goBack()">{{'Go back' | translate}}</button>
          <button type="submit" class="btn btn-primary" [disabled]="newPasswordForm.invalid" (click)="submitForm()">
            <span *ngIf="!isLoading">{{ 'Reset password' | translate | uppercase }}</span>
            <div *ngIf="isLoading" class="spinner-border"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
